export class SetArticleSuggestionModel {
    public ArticleSuggestionId : string;
}